// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    console.log("test");

    const swiper = new Swiper(".top-mv-swiper", {
      loop: true,
      effect: 'fade',
      speed: 800,
      autoplay: {     //追記
        delay: 3000,   //追記
      },
      allowTouchMove: false,
    });

  }
}
class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(function () {
      $(".acc-trigger").on("click", function () {
        $(this).next().slideToggle(300);
        $(this).toggleClass("is-open", 300);
      });
    });  
  }
}
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).parent().parent().parent().next().addClass('c-accordion__inner').css({'display': 'none'});
    $("." + this.el).parent().parent().parent().parent().addClass('c-accordion__wrap')

    $("." + this.el).on('click', function() {
      $(this).toggleClass('is-active');
      $(this).parent().parent().parent().next().slideToggle();
    })
  }
}
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-editor p').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })
  }
}
class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');
    
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    }, 800);
  }
}
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-modal-inner').parent().clone().insertBefore('.c-modal .c-modal-clone');

    $('main .c-modal-inner').parent().remove();

    const body = document.getElementsByTagName('body')[0];
    let scrollTop = 0;

    $(".c-modal-inner").parent().addClass('u-mt-0');

    $(".c-modal-trigger").on("click", function() {
      $(`#${$(this).data('id')}, .c-modal-overlay`).addClass('is-active');

      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('no_scroll');

      return false;
    })

    $(".c-modal-close, .c-modal-overlay").on("click", function() {
      $(`.c-modal-inner, .c-modal-overlay`).removeClass('is-active');
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    })
  }
}
class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper', {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,  
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-tab-trigger').parent().parent().parent().addClass('u-mb-0');
    $(".c-tab-inner").parent().addClass('c-tab-wrap');
    $(".c-tab-wrap").eq(0).css({'display': 'block'});

    $(".c-tab-trigger li").on('click', function() {
      let el_num = $(this).index();
      $(".c-tab-trigger li").removeClass('is-active');
      $(this).addClass('is-active');

      $('.c-tab-wrap').css({'display': 'none'});
      $('.c-tab-wrap').eq(el_num).css({'display': 'block'});
    })
  }
}
//noScroll
class Common {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // let elFs;

    // $('.c-content *').each(function() {

    //   let css = ['font-size', 'padding-left', 'padding-top', 'padding-right', 'padding-bottom', 'margin-left', 'margin-top', 'margin-right', 'margin-bottom']
    //   let this_el = $(this);

    //   css.forEach(el => {
    //     elFs = this_el.css(el);
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     this_el.css(el, elFs);
    //   });

    //   // height
    //   if($(this).prop('nodeName').match(/TABLE|TD|TR|TBODY/)) {
    //     elFs = $(this).css('height');
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     $(this).css('height', elFs);
    //   }
    // })  

    // $('.c-content p').each(function() {
    //   if($(this)[0].innerHTML == '&nbsp;') {
    //     $(this)[0].innerHTML = '';
    //   }
    // });
  }
}
class ContactFile {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const fileBox = document.querySelector('.upload-box');
    const fileName = document.querySelector('.upload-file');

    // fileName.addEventListener('change', () => {
    //   console.log("変更が加えられました");
    // });
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormCheckbox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const checkBox = document.querySelector('.mwform-checkbox-field-text');
    checkBox.innerHTML = `<span><a href="https://betrading.jp/saiyou/policy/" name="consent" target="_blank" class="policy-link">プライバシーポリシー</a>に同意する</span>`
  }
}

class FormEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const item = document.querySelector('.item');
    const area = document.querySelector('.contact-area');

    if(item) {
      item.addEventListener('change', () => {
        const selectValue =  document.querySelector('.item').value;

        if( selectValue === 'sales' || selectValue === 'risk' ){
          area.classList.add('is-active')
        } else {
          area.classList.remove('is-active')
        }
      })
    }

    if($('[name="expect"').val() === 'sales' || $('[name="expect"').val() === 'risk') {
      area.classList.add('is-active')
    }

  }
}

class HamburgerMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const humBtn = document.querySelector('.js-hum');
    const entryNone = document.querySelector('.hum-none');
    const headerLogo = document.querySelector('.h-logo');
    const humMenu = document.querySelector('.humMenu');
    const body = document.querySelector('body');

    humBtn.addEventListener('click', ()=> {
      humMenu.classList.toggle('is-active');
      humBtn.classList.toggle('is-active');
      body.classList.toggle('no-scroll');
      setTimeout(() => {
        entryNone.classList.toggle('is-hidden');
      },200);
      setTimeout(() => {
        headerLogo.classList.toggle('is-active');
      },400);
    })


    function isMobile() {
      return window.innerWidth <= 768;
    }
    
    $('.js-acc-trigger').on('click', function(e) {
      if (isMobile()) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        $(this).next('.js-acc-content').slideToggle();
      }
    });
  
    $(window).on('resize', function() {
      if (!isMobile()) {
        $('.js-acc-content').removeAttr('style');
        $('.js-acc-trigger').removeClass('is-active');
      }
    });

  }
}

//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InstaSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const mySwiper = new Swiper('.swiper', {
      loop: true,
      slidesPerView: 3.2,
      spaceBetween: 16,
      speed: 5000,
      preventInteractionOnTransition: false,
      disableOnInteraction: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      mousewheel: {
        forceToAxis: true,
        sensitivity: 3
      },
      breakpoints: {
        768: {
          slidesPerView: 6.8,
          spaceBetween: 20,
        },
        1800: {
          slidesPerView: 9.4,
          spaceBetween: 20,
        },
      }
    });
  }
}
class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class TabChange {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    
    (function ($) {
      const item01 = document.querySelector('#pg-1089-0');
      const item02 = document.querySelector('#pg-1089-1');
      item01.classList.add('tabChange');
      item01.classList.add('is-show');
      item02.classList.add('tabChange');

      //任意のタブにURLからリンクするための設定
      function GethashID (hashIDName){
        console.log(hashIDName);
        if(hashIDName){
          //タブ設定
          $('.tabMenu__item').find('a').each(function() {
            var idName = $(this).attr('href');
            if(idName == hashIDName){
              var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
              $('.tabMenu__item').removeClass("is-active"); //タブ内のliについているactiveクラスを取り除き
              $(parentElm).addClass("is-active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
              //表示させるエリア設定
              $(".tabChange").removeClass("is-show"); 
              $(hashIDName).addClass("is-show"); 
            }
          });
        }
      }
    
      //タブをクリックしたら
      $('.tabMenu__item a').on('click', function() {
        var idName = $(this).attr('href'); //タブ内のリンク名を取得	
        $('.tabMenu__item').removeClass("is-active");
        GethashID (idName);//設定したタブの読み込みと
        return false;//aタグを無効にする
      });
    
      // 上記の動きをページが読み込まれたらすぐに動かす
      $(window).on('load', function () {
          $('.tabMenu__item:nth-of-type(1)').addClass("is-active"); //最初のliにactiveクラスを追加
          $('.tabChange:nth-of-type(1)').addClass("is-show"); //最初の.areaにis-activeクラスを追加
        var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
        GethashID (hashName);//設定したタブの読み込み
      });
    
    })(jQuery);
  }
}

//noScroll
class TextAnimation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-strip').each(function(){
      var $t = $(this),
      rows = $.trim($t.html()).split('<br>');

      $t.html('');

      $.each(rows, function(i, val){
        $('<h2 class="row"></h2>').appendTo($t);

        var letters = $.trim(val).split('');

        $.each(letters, function(j, v){
          v = (v == ' ') ? '&nbsp;' : v;
          $('<h2 class="textWord">' + $.trim(v) + '</h2>').appendTo($('.row:last', $t));
        });
      });
    });



    //ターゲット要素をDOMで取得
    const target = document.querySelectorAll(".js-strip");
    target.forEach(el => {


      //オプション
      const options = {
        childList: true,
        characterData: true,
        characterDataOldValue: true,
        attributes: true,
        subtree: true,
      }

      //コールバック関数
      function callback(mutationsList, observer) {
        for(const mutation of mutationsList) {
            // 処理
            mutation.target //ターゲット要素
            mutation.addedNodes //追加されたDOM
            mutation.removedNodes //削除されたDOM

            const elWords = el.querySelectorAll(".textWord")

            let time = mutation.target.classList.contains('js-short') ? '30' : '50';

            for (let i = 0; i < elWords.length; i++) {
              (function(ind) {
                setTimeout(function(){
                  elWords[i].classList.add("animate")
                }, ind * time);
              })(i);
            }

        }
        //ターゲット要素の監視を停止
        obs.disconnect();
      }

      //インスタンス化
      const obs = new MutationObserver(callback);
      //ターゲット要素の監視を開始
      obs.observe(el, options);
    })







  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let common = new Common('c-content');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let accordionEvent = new AccordionEvent('acc-trigger');
  let hamburgerMenu = new HamburgerMenu('js-hum');
  let textAnimation = new TextAnimation('js-textAnimation');
  let formCheckbox = new FormCheckbox('js-mw-checkbox');
  let tabChange = new TabChange('p-requirement');
  let formEvent = new FormEvent('p-mid-career');
  let contactFile = new ContactFile('p-mid-career');
  let top = new Top('p-top');
  let instaSwiper = new InstaSwiper('js-instaswiper');

  // 以下ページビルダー用
  let accordion = new Accordion('c-accordion');
  let modal = new Modal('c-modal-trigger');
  let tab = new Tab('c-tab-trigger');
  let swiper = new Slider('c-swiper');
  let loading = new Loading('c-loading');
  let editor = new Editor('c-editor');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });